import React from 'react'
import ReactDOM from 'react-dom/client'
import { RecoilRoot } from 'recoil'

import { WalletSelectorContextProvider } from '@/contexts/WalletSelectorContext'
import App from './App'
import reportWebVitals from './reportWebVitals'
import '@near-wallet-selector/modal-ui-js/styles.css'
import './index.css'

const APP_VERSION_LABEL = `👻 ${process.env.APP_VERSION_HASH}`
const VERSION_LABEL_STYLES = [
  'font-weight: bold',
  'background: #060f26',
  'padding: 3px 7px',
  'border-radius: 3px',
  'color: #fff'
].join(';')

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <React.StrictMode>
    <RecoilRoot>
      <WalletSelectorContextProvider>
        <App />
      </WalletSelectorContextProvider>
    </RecoilRoot>
  </React.StrictMode>
)

console.log(`%c%s`, VERSION_LABEL_STYLES, APP_VERSION_LABEL)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
